module.exports = __webpack_public_path__ + "static/5-224c106cb3247ed9105f1e9e120ba741.png";